import { render, staticRenderFns } from "./FollowUpDice.vue?vue&type=template&id=11ccf076"
import script from "./FollowUpDice.vue?vue&type=script&lang=js"
export * from "./FollowUpDice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports